// import { Injectable } from '@angular/core';
// import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
// import { map } from 'rxjs/operators';
// import { Observable } from 'rxjs';
// import { CoreGymService } from '../../_services/core.gym.service.service';
// import { Account } from '../../model/account.model';
// import { AccountLogin } from '../../model/AccountLogin.model';
// import { Guid } from '../../_helpers/guid';

// @Injectable({
//   providedIn: 'root'
// })
// export class AccountService {

//   constructor(
//     private readonly http: HttpClient,
//     private readonly coreGymService: CoreGymService
//   ) {
//   }

//   mergeAccount(account: Account, action: string): Observable<Response> {
//     let httpheader = new HttpHeaders();
//     httpheader = httpheader.append('Content-Type', 'application/json');
//     let url: string = this.coreGymService.BaseUrl!;
//     url = url + this.coreGymService.serviceUrls!['GetAccountUrl'];
//     if (action === 'Edit' || action === 'Delete') {
//       url = url + '/' + account.abgTechnologysAccountUId;
//       return this.http.put(url, JSON.stringify(account), { 'headers': httpheader })
//         .pipe(map((data: Response) => data,
//           (error: HttpErrorResponse): void => {
//             console.log(error);
//           }
//         ));
//     } else {
//       return this.http.post(url, JSON.stringify(account), { 'headers': httpheader })
//         .pipe(map((data: Response) => data,
//           (error: HttpErrorResponse): void => {
//             console.log(error);
//           }
//         ));
//     }
//   }
//   /* (accountUId?: string):*/
//   getAccount(clientRegistrationUId?: string, productUId?: string): Observable<Array<Account>> {
//     let url: string = this.coreGymService.BaseUrl!;
//     url = url + this.coreGymService.serviceUrls!['GetAccountClientandProductUrl'];
//     url = url.replace('{clientRegistrationUId}', clientRegistrationUId ? clientRegistrationUId : Guid.empty);
//     url = url.replace('{productUId}', productUId ? productUId : Guid.empty);
//     //url = url.replace('{RegistrationUId}', RegistrationUId ? RegistrationUId : Guid.empty);

//     //url = url + '/' + accountUId;
//     //url = url.replace('{RegistrationUId}', accountUId ? accountUId : Guid.empty);

//     return this.http.get(url)
//       .pipe(map((data: Array<Account>): Array<Account> => data, (_error: HttpErrorResponse) => { }));

//   }

//   getAccountUId(abgTechnologysAccountUId?: string): Observable<Array<Account>> {
//     let url: string = this.coreGymService.BaseUrl!;
//     if (abgTechnologysAccountUId) {
//       url = url + this.coreGymService.serviceUrls!['GetAccountUIdUrl'];
//       url = url.replace('{id}', abgTechnologysAccountUId ? abgTechnologysAccountUId : Guid.empty);
//       return this.http.get(url)
//         .pipe(map((data: Array<Account>): Array<Account> => data, (_error: HttpErrorResponse) => { }));
//     }
//     else {
//       url = url + this.coreGymService.serviceUrls!['GetAccountUrl'];
//       return this.http.get(url)
//         .pipe(map((data: Array<Account>): Array<Account> => data, (_error: HttpErrorResponse) => { }));
//     }

//   }
//   getAccountLogin(EmailId: string, Password: string): Observable<Array<Account>> {
//     let url: string = this.coreGymService.BaseUrl!;
//     url = url + this.coreGymService.serviceUrls!['AccountLogin'];
//     url = url.replace('{EmailId}', EmailId ? EmailId : "");
//     url = url.replace('{Password}', Password ? Password : "");
//     let httpheader = new HttpHeaders();
//     httpheader = httpheader.append('Content-Type', 'application/json');
//     return this.http.get(url)
//       .pipe(map((data: Array<Account>): Array<Account> => data, (_error: HttpErrorResponse) => { }));
//   }
//   getAccountEmail(EmailId: string): Observable<Account> {
//     let url: string = this.coreGymService.BaseUrl!;
//     url = url + this.coreGymService.serviceUrls!['AccountEmail'];
//     url = url.replace('{EmailId}', EmailId ? EmailId : "");
//     let httpheader = new HttpHeaders();
//     httpheader = httpheader.append('Content-Type', 'application/json');
//     return this.http.get(url)
//       .pipe(map((data: Account): Account => data, (_error: HttpErrorResponse) => { }));
//   }


//   deleteAccount(accountUId: Guid): Observable<Array<Account>> {
//     let url: string = this.coreGymService.BaseUrl!;
//     url = url + this.coreGymService.serviceUrls!['GetAccountUrl'];
//     url = url + '/' + accountUId;
//     return this.http.delete(url)
//       .pipe(map((data: Array<Account>): Array<Account> => data, (_error: HttpErrorResponse) => { }));

//   }
//   getAccountId(accountUId?: Guid): Observable<Account> {
//     let url: string = this.coreGymService.BaseUrl!;
//     url = url + this.coreGymService.serviceUrls!['GetAccountMaxIdUrl'];
//     return this.http.get(url)
//       .pipe(map((data: Account): Account => data, (_error: HttpErrorResponse) => { }));

//   }
//   forgotsendmailpassword(account: Account) {
//     //let httpheader = new HttpHeaders();
//     //httpheader = httpheader.append('Content-Type', 'application/json');
//     let url: string = this.coreGymService.BaseUrl!;
//     url = url + this.coreGymService.serviceUrls!['GetforgotsendmailpasswordUrl'];
//     url = url + '/' + account.abgTechnologysAccountUId;
//     return this.http.put(url, JSON.stringify(account)/*, { 'headers': httpheader }*/)
//       .pipe(map((data: Response) => data,
//         (error: HttpErrorResponse): void => {
//           console.log(error);
//         }
//       ));
//   }

//   sendOtp(channel: 'email' | 'mobile', target: string): Observable<any> {
//     let url: string = this.coreGymService.BaseUrl!;
//     url = url + this.coreGymService.serviceUrls!['SendOtpAccountUrl'];
//     url = url.replace('{channel}', channel);
//     url = url.replace('{target}', encodeURIComponent(target));
//     return this.http.post(url, null)
//       .pipe(map((data: any) => data, (_error: HttpErrorResponse) => { }));
//   }

//   verifyOtp(target: string, code: string): Observable<any> {
//     let url: string = this.coreGymService.BaseUrl!;
//     url = url + this.coreGymService.serviceUrls!['VerifyOtpAccountUrl'];
//     url = url.replace('{target}', encodeURIComponent(target));
//     url = url.replace('{code}', code);
//     return this.http.post(url, null)
//       .pipe(map((data: any) => data, (_error: HttpErrorResponse) => { }));
//   }

//   /* ─── REGISTER ────────────────────────────────────────────────
//      serviceUrls example:
//        'RegisterAccountUrl' : 'api/ABGTechnologysAccounts/Register'
//      Server fans the chosen products out into ABGTechnologysAccount
//      rows (or an AccountProduct mapping table).
//   */
//   register(payload: {
//     fullName: string; email: string; mobile: string;
//     password: string; products: string[];
//   }): Observable<any> {
//     let httpheader = new HttpHeaders();
//     httpheader = httpheader.append('Content-Type', 'application/json');
//     let url: string = this.coreGymService.BaseUrl!;
//     url = url + this.coreGymService.serviceUrls!['RegisterAccountUrl'];
//     return this.http.post(url, JSON.stringify(payload), { headers: httpheader })
//       .pipe(map((data: any) => data, (_error: HttpErrorResponse) => { }));
//   }

//   /* ─── PASSWORD RESET ──────────────────────────────────────────
//      serviceUrls example:
//        'RequestPasswordResetUrl' : 'api/ABGTechnologysAccounts/RequestPasswordReset?EmailId={EmailId}'
//        'ResetPasswordUrl'        : 'api/ABGTechnologysAccounts/ResetPassword'
//        'ValidateResetTokenUrl'   : 'api/ABGTechnologysAccounts/ValidateResetToken?token={token}'
//   */
//   requestPasswordReset(email: string): Observable<any> {
//     let url: string = this.coreGymService.BaseUrl!;
//     url = url + this.coreGymService.serviceUrls!['RequestPasswordResetUrl'];
//     url = url.replace('{EmailId}', encodeURIComponent(email));
//     return this.http.post(url, null)
//       .pipe(map((data: any) => data, (_error: HttpErrorResponse) => { }));
//   }

//   resetPassword(token: string, newPassword: string): Observable<any> {
//     let httpheader = new HttpHeaders();
//     httpheader = httpheader.append('Content-Type', 'application/json');
//     let url: string = this.coreGymService.BaseUrl!;
//     url = url + this.coreGymService.serviceUrls!['ResetPasswordAccountUrl'];
//     const body = { token: token, password: newPassword };
//     return this.http.post(url, JSON.stringify(body), { headers: httpheader })
//       .pipe(map((data: any) => data, (_error: HttpErrorResponse) => { }));
//   }

//   validateResetToken(token: string): Observable<any> {
//     let url: string = this.coreGymService.BaseUrl!;
//     url = url + this.coreGymService.serviceUrls!['ValidateResetTokenUrl'];
//     url = url.replace('{token}', encodeURIComponent(token));
//     return this.http.get(url)
//       .pipe(map((data: any) => data, (_error: HttpErrorResponse) => { }));
//   }

// }




// import { Injectable } from '@angular/core';
// import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
// import { map } from 'rxjs/operators';
// import { Observable } from 'rxjs';
// import { CoreGymService } from '../../_services/core.gym.service.service';
// import { Account } from '../../model/account.model';
// import { AccountLogin } from '../../model/AccountLogin.model';
// import { Guid } from '../../_helpers/guid';

// @Injectable({
//   providedIn: 'root'
// })
// export class AccountService {

//   constructor(
//     private readonly http: HttpClient,
//     private readonly coreGymService: CoreGymService
//   ) {
//   }

//   mergeAccount(account: Account, action: string): Observable<Response> {
//     let httpheader = new HttpHeaders();
//     httpheader = httpheader.append('Content-Type', 'application/json');
//     let url: string = this.coreGymService.BaseUrl!;
//     url = url + this.coreGymService.serviceUrls!['GetAccountUrl'];
//     if (action === 'Edit' || action === 'Delete') {
//       url = url + '/' + account.abgTechnologysAccountUId;
//       return this.http.put(url, JSON.stringify(account), { 'headers': httpheader })
//         .pipe(map((data: Response) => data,
//           (error: HttpErrorResponse): void => {
//             console.log(error);
//           }
//         ));
//     } else {
//       return this.http.post(url, JSON.stringify(account), { 'headers': httpheader })
//         .pipe(map((data: Response) => data,
//           (error: HttpErrorResponse): void => {
//             console.log(error);
//           }
//         ));
//     }
//   }
//   /* (accountUId?: string):*/
//   getAccount(clientRegistrationUId?: string, productUId?: string): Observable<Array<Account>> {
//     let url: string = this.coreGymService.BaseUrl!;
//     url = url + this.coreGymService.serviceUrls!['GetAccountClientandProductUrl'];
//     url = url.replace('{clientRegistrationUId}', clientRegistrationUId ? clientRegistrationUId : Guid.empty);
//     url = url.replace('{productUId}', productUId ? productUId : Guid.empty);
//     //url = url.replace('{RegistrationUId}', RegistrationUId ? RegistrationUId : Guid.empty);

//     //url = url + '/' + accountUId;
//     //url = url.replace('{RegistrationUId}', accountUId ? accountUId : Guid.empty);

//     return this.http.get(url)
//       .pipe(map((data: Array<Account>): Array<Account> => data, (_error: HttpErrorResponse) => { }));

//   }

//   getAccountUId(abgTechnologysAccountUId?: string): Observable<Array<Account>> {
//     let url: string = this.coreGymService.BaseUrl!;
//     if (abgTechnologysAccountUId) {
//       url = url + this.coreGymService.serviceUrls!['GetAccountUIdUrl'];
//       url = url.replace('{id}', abgTechnologysAccountUId ? abgTechnologysAccountUId : Guid.empty);
//       return this.http.get(url)
//         .pipe(map((data: Array<Account>): Array<Account> => data, (_error: HttpErrorResponse) => { }));
//     }
//     else {
//       url = url + this.coreGymService.serviceUrls!['GetAccountUrl'];
//       return this.http.get(url)
//         .pipe(map((data: Array<Account>): Array<Account> => data, (_error: HttpErrorResponse) => { }));
//     }

//   }
//   getAccountLogin(EmailId: string, Password: string): Observable<Array<Account>> {
//     let url: string = this.coreGymService.BaseUrl!;
//     url = url + this.coreGymService.serviceUrls!['AccountLogin'];
//     url = url.replace('{EmailId}', EmailId ? EmailId : "");
//     url = url.replace('{Password}', Password ? Password : "");
//     let httpheader = new HttpHeaders();
//     httpheader = httpheader.append('Content-Type', 'application/json');
//     return this.http.get(url)
//       .pipe(map((data: Array<Account>): Array<Account> => data, (_error: HttpErrorResponse) => { }));
//   }
//   getAccountEmail(EmailId: string): Observable<Account> {
//     let url: string = this.coreGymService.BaseUrl!;
//     url = url + this.coreGymService.serviceUrls!['AccountEmail'];
//     url = url.replace('{EmailId}', EmailId ? EmailId : "");
//     let httpheader = new HttpHeaders();
//     httpheader = httpheader.append('Content-Type', 'application/json');
//     return this.http.get(url)
//       .pipe(map((data: Account): Account => data, (_error: HttpErrorResponse) => { }));
//   }


//   deleteAccount(accountUId: Guid): Observable<Array<Account>> {
//     let url: string = this.coreGymService.BaseUrl!;
//     url = url + this.coreGymService.serviceUrls!['GetAccountUrl'];
//     url = url + '/' + accountUId;
//     return this.http.delete(url)
//       .pipe(map((data: Array<Account>): Array<Account> => data, (_error: HttpErrorResponse) => { }));

//   }
//   getAccountId(accountUId?: Guid): Observable<Account> {
//     let url: string = this.coreGymService.BaseUrl!;
//     url = url + this.coreGymService.serviceUrls!['GetAccountMaxIdUrl'];
//     return this.http.get(url)
//       .pipe(map((data: Account): Account => data, (_error: HttpErrorResponse) => { }));

//   }
//   forgotsendmailpassword(account: Account) {
//       //let httpheader = new HttpHeaders();
//       //httpheader = httpheader.append('Content-Type', 'application/json');
//       let url: string = this.coreGymService.BaseUrl!;
//       url = url + this.coreGymService.serviceUrls!['GetforgotsendmailpasswordUrl'];
//       url = url + '/' + account.abgTechnologysAccountUId;
//       return this.http.put(url, JSON.stringify(account)/*, { 'headers': httpheader }*/)
//         .pipe(map((data: Response) => data,
//           (error: HttpErrorResponse): void => {
//             console.log(error);
//           }
//         ));
//     }

//   sendOtp(channel: 'email' | 'mobile', target: string): Observable<any> {
//     let url: string = this.coreGymService.BaseUrl!;
//     url = url + this.coreGymService.serviceUrls!['SendOtpAccountUrl'];
//     url = url.replace('{channel}', channel);
//     url = url.replace('{target}', encodeURIComponent(target));
//     return this.http.post(url)
//       .pipe(map((data: any) => data, (_error: HttpErrorResponse) => { }));
//   }

//   verifyOtp(target: string, code: string): Observable<any> {
//     let url: string = this.coreGymService.BaseUrl!;
//     url = url + this.coreGymService.serviceUrls!['VerifyOtpAccountUrl'];
//     url = url.replace('{target}', encodeURIComponent(target));
//     url = url.replace('{code}', code);
//     return this.http.post(url)
//       .pipe(map((data: any) => data, (_error: HttpErrorResponse) => { }));
//   }

//   /* ─── REGISTER ────────────────────────────────────────────────
//      serviceUrls example:
//        'RegisterAccountUrl' : 'api/ABGTechnologysAccounts/Register'
//      Server fans the chosen products out into ABGTechnologysAccount
//      rows (or an AccountProduct mapping table).
//   */
//   register(payload: {
//     fullName: string; email: string; mobile: string;
//     password: string; products: string[];
//   }): Observable<any> {
//     let httpheader = new HttpHeaders();
//     httpheader = httpheader.append('Content-Type', 'application/json');
//     let url: string = this.coreGymService.BaseUrl!;
//     url = url + this.coreGymService.serviceUrls!['RegisterAccountUrl'];
//     return this.http.post(url, JSON.stringify(payload), { headers: httpheader })
//       .pipe(map((data: any) => data, (_error: HttpErrorResponse) => { }));
//   }

//   /* ─── PASSWORD RESET ──────────────────────────────────────────
//      serviceUrls example:
//        'RequestPasswordResetUrl' : 'api/ABGTechnologysAccounts/RequestPasswordReset?EmailId={EmailId}'
//        'ResetPasswordUrl'        : 'api/ABGTechnologysAccounts/ResetPassword'
//        'ValidateResetTokenUrl'   : 'api/ABGTechnologysAccounts/ValidateResetToken?token={token}'
//   */
//   requestPasswordReset(email: string): Observable<any> {
//     let url: string = this.coreGymService.BaseUrl!;
//     url = url + this.coreGymService.serviceUrls!['RequestPasswordResetUrl'];
//     url = url.replace('{EmailId}', encodeURIComponent(email));
//     return this.http.post(url, null)
//       .pipe(map((data: any) => data, (_error: HttpErrorResponse) => { }));
//   }

//   resetPassword(token: string, newPassword: string): Observable<any> {
//     let httpheader = new HttpHeaders();
//     httpheader = httpheader.append('Content-Type', 'application/json');
//     let url: string = this.coreGymService.BaseUrl!;
//     url = url + this.coreGymService.serviceUrls!['ResetPasswordAccountUrl'];
//     const body = { token: token, password: newPassword };
//     return this.http.post(url, JSON.stringify(body), { headers: httpheader })
//       .pipe(map((data: any) => data, (_error: HttpErrorResponse) => { }));
//   }

//   validateResetToken(token: string): Observable<any> {
//     let url: string = this.coreGymService.BaseUrl!;
//     url = url + this.coreGymService.serviceUrls!['ValidateResetTokenUrl'];
//     url = url.replace('{token}', encodeURIComponent(token));
//     return this.http.get(url)
//       .pipe(map((data: any) => data, (_error: HttpErrorResponse) => { }));
//   }

// }


// import { Injectable } from '@angular/core';
// import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
// import { map } from 'rxjs/operators';
// import { Observable } from 'rxjs';
// import { CoreGymService } from '../../_services/core.gym.service.service';
// import { Account } from '../../model/account.model';
// import { Guid } from '../../_helpers/guid';

// @Injectable({
//   providedIn: 'root'
// })
// export class AccountService {

//   constructor(
//     private readonly http: HttpClient,
//     private readonly coreGymService: CoreGymService
//   ) { }

//   private jsonHeaders(): HttpHeaders {
//     let httpheader = new HttpHeaders();
//     httpheader = httpheader.append('Content-Type', 'application/json');
//     return httpheader;
//   }

//   private buildUrl(path: string): string {
//     const baseUrl = this.coreGymService.BaseUrl || '';
//     if (!baseUrl.endsWith('/') && !path.startsWith('/')) {
//       return baseUrl + '/' + path;
//     }
//     return baseUrl + path;
//   }

//   mergeAccount(account: Account, action: string): Observable<Response> {
//     const httpheader = this.jsonHeaders();
//     let url: string = this.coreGymService.BaseUrl!;
//     url = url + this.coreGymService.serviceUrls!['GetAccountUrl'];

//     if (action === 'Edit' || action === 'Delete') {
//       url = url + '/' + account.abgTechnologysAccountUId;
//       return this.http.put(url, JSON.stringify(account), { headers: httpheader })
//         .pipe(map((data: Response) => data, (error: HttpErrorResponse): void => console.log(error)));
//     }

//     return this.http.post(url, JSON.stringify(account), { headers: httpheader })
//       .pipe(map((data: Response) => data, (error: HttpErrorResponse): void => console.log(error)));
//   }

//   getAccount(clientRegistrationUId?: string, productUId?: string): Observable<Array<Account>> {
//     let url: string = this.coreGymService.BaseUrl!;
//     url = url + this.coreGymService.serviceUrls!['GetAccountClientandProductUrl'];
//     url = url.replace('{clientRegistrationUId}', clientRegistrationUId ? clientRegistrationUId : Guid.empty);
//     url = url.replace('{productUId}', productUId ? productUId : Guid.empty);

//     return this.http.get(url)
//       .pipe(map((data: Array<Account>): Array<Account> => data, (_error: HttpErrorResponse) => { }));
//   }

//   getAccountUId(abgTechnologysAccountUId?: string): Observable<Array<Account>> {
//     let url: string = this.coreGymService.BaseUrl!;

//     if (abgTechnologysAccountUId) {
//       url = url + this.coreGymService.serviceUrls!['GetAccountUIdUrl'];
//       url = url.replace('{id}', abgTechnologysAccountUId ? abgTechnologysAccountUId : Guid.empty);
//       return this.http.get(url)
//         .pipe(map((data: Array<Account>): Array<Account> => data, (_error: HttpErrorResponse) => { }));
//     }

//     url = url + this.coreGymService.serviceUrls!['GetAccountUrl'];
//     return this.http.get(url)
//       .pipe(map((data: Array<Account>): Array<Account> => data, (_error: HttpErrorResponse) => { }));
//   }

//   getAccountLogin(EmailId: string, Password: string): Observable<Array<Account>> {
//     let url: string = this.coreGymService.BaseUrl!;
//     url = url + this.coreGymService.serviceUrls!['AccountLogin'];
//     url = url.replace('{EmailId}', EmailId ? EmailId : '');
//     url = url.replace('{Password}', Password ? Password : '');

//     return this.http.get(url)
//       .pipe(map((data: Array<Account>): Array<Account> => data, (_error: HttpErrorResponse) => { }));
//   }

//   getAccountEmail(EmailId: string): Observable<Account> {
//     let url: string = this.coreGymService.BaseUrl!;
//     url = url + this.coreGymService.serviceUrls!['AccountEmail'];
//     url = url.replace('{EmailId}', EmailId ? EmailId : '');

//     return this.http.get(url)
//       .pipe(map((data: Account): Account => data, (_error: HttpErrorResponse) => { }));
//   }

//   deleteAccount(accountUId: Guid): Observable<Array<Account>> {
//     let url: string = this.coreGymService.BaseUrl!;
//     url = url + this.coreGymService.serviceUrls!['GetAccountUrl'];
//     url = url + '/' + accountUId;

//     return this.http.delete(url)
//       .pipe(map((data: Array<Account>): Array<Account> => data, (_error: HttpErrorResponse) => { }));
//   }

//   getAccountId(accountUId?: Guid): Observable<Account> {
//     let url: string = this.coreGymService.BaseUrl!;
//     url = url + this.coreGymService.serviceUrls!['GetAccountMaxIdUrl'];

//     return this.http.get(url)
//       .pipe(map((data: Account): Account => data, (_error: HttpErrorResponse) => { }));
//   }

//   sendOtp(channel: 'email' | 'mobile', target: string): Observable<any> {
//     let url: string = this.coreGymService.BaseUrl!;
//     url = url + this.coreGymService.serviceUrls!['SendOtpAccountUrl'];
//     url = url.replace('{channel}', channel);
//     url = url.replace('{target}', encodeURIComponent(target));

//     return this.http.get(url)
//       .pipe(map((data: any) => data, (_error: HttpErrorResponse) => { }));
//   }

//   verifyOtp(target: string, code: string): Observable<any> {
//     let url: string = this.coreGymService.BaseUrl!;
//     url = url + this.coreGymService.serviceUrls!['VerifyOtpAccountUrl'];
//     url = url.replace('{target}', encodeURIComponent(target));
//     url = url.replace('{code}', encodeURIComponent(code));

//     return this.http.get(url)
//       .pipe(map((data: any) => data, (_error: HttpErrorResponse) => { }));
//   }

//   register(payload: {
//     fullName: string;
//     email: string;
//     mobile: string;
//     password: string;
//     productCode: string;
//     acceptTerms: boolean;
//   }): Observable<any> {
//     const url = this.buildUrl('api/auth/register/start');

//     return this.http.post(url, JSON.stringify(payload), { headers: this.jsonHeaders() })
//       .pipe(map((data: any) => data, (_error: HttpErrorResponse) => { }));
//   }

//   registerVerify(payload: {
//     email: string;
//     emailCode: string;
//     mobile?: string;
//     mobileCode?: string;
//   }): Observable<any> {
//     const url = this.buildUrl('api/auth/register/verify');

//     return this.http.post(url, JSON.stringify(payload), { headers: this.jsonHeaders() })
//       .pipe(map((data: any) => data, (_error: HttpErrorResponse) => { }));
//   }

//   requestPasswordReset(email: string): Observable<any> {
//     let url: string = this.coreGymService.BaseUrl!;
//     url = url + this.coreGymService.serviceUrls!['RequestPasswordResetUrl'];
//     url = url.replace('{EmailId}', encodeURIComponent(email));

//     return this.http.get(url)
//       .pipe(map((data: any) => data, (_error: HttpErrorResponse) => { }));
//   }

//   resetPassword(target: string, code: string, newPassword: string): Observable<any> {
//     const url = this.buildUrl('api/ABGTechnologysAccounts/ResetPassword');
//     const body = { target, code, newPassword };

//     return this.http.post(url, JSON.stringify(body), { headers: this.jsonHeaders() })
//       .pipe(map((data: any) => data, (_error: HttpErrorResponse) => { }));
//   }

//   validateResetToken(token: string): Observable<any> {
//     let url: string = this.coreGymService.BaseUrl!;
//     url = url + this.coreGymService.serviceUrls!['ValidateResetTokenUrl'];
//     url = url.replace('{token}', encodeURIComponent(token));

//     return this.http.get(url)
//       .pipe(map((data: any) => data, (_error: HttpErrorResponse) => { }));
//   }
// }


// import { Injectable } from '@angular/core';
// import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
// import { map, Observable } from 'rxjs';
// import { environment } from '../../../environments/environment'; // <-- fix path if your env file differs
// import { Account } from '../../model/account.model';
// import { CoreGymService } from '../../_services/core.gym.service.service';
// import { Guid } from '../../_helpers/guid';

// /**
//  * AccountService — auth/registration calls used by the unified register wizard + AccountCreation grid.
//  *
//  * IMPORTANT: register() and registerVerify() post the WHOLE payload object as-is, so the new
//  * `company` block reaches the backend untouched. That was the seam that would otherwise silently
//  * drop CompanyDetails.
//  *
//  * If your existing AccountService has other methods (it does — e.g. getAccount is used by
//  * Clientinfo/AccountCreation), keep them; just make sure register/registerVerify look like this.
//  */
// @Injectable({ providedIn: 'root' })
// export class AccountService {


//   private readonly api = "https://localhost:7027/api/";

//   constructor(private readonly http: HttpClient,
//     private readonly coreGymService: CoreGymService) { }

//   private jsonHeaders(): HttpHeaders {
//       let httpheader = new HttpHeaders();
//       httpheader = httpheader.append('Content-Type', 'application/json');
//       return httpheader;
//     }

//     private buildUrl(path: string): string {
//       const baseUrl = this.coreGymService.BaseUrl || '';
//       if (!baseUrl.endsWith('/') && !path.startsWith('/')) {
//         return baseUrl + '/' + path;
//       }
//       return baseUrl + path;
//     }


//   mergeAccount(account: Account, action: string): Observable<Response> {
//       const httpheader = this.jsonHeaders();
//       let url: string = this.coreGymService.BaseUrl!;
//       url = url + this.coreGymService.serviceUrls!['GetAccountUrl'];

//       if (action === 'Edit' || action === 'Delete') {
//         url = url + '/' + account.abgTechnologysAccountUId;
//         return this.http.put(url, JSON.stringify(account), { headers: httpheader })
//           .pipe(map((data: Response) => data, (error: HttpErrorResponse): void => console.log(error)));
//       }

//       return this.http.post(url, JSON.stringify(account), { headers: httpheader })
//         .pipe(map((data: Response) => data, (error: HttpErrorResponse): void => console.log(error)));
//     }

//     getAccount(clientRegistrationUId?: string, productUId?: string): Observable<Array<Account>> {
//       let url: string = this.coreGymService.BaseUrl!;
//       url = url + this.coreGymService.serviceUrls!['GetAccountClientandProductUrl'];
//       url = url.replace('{clientRegistrationUId}', clientRegistrationUId ? clientRegistrationUId : Guid.empty);
//       url = url.replace('{productUId}', productUId ? productUId : Guid.empty);

//       return this.http.get(url)
//         .pipe(map((data: Array<Account>): Array<Account> => data, (_error: HttpErrorResponse) => { }));
//     }

//     getAccountUId(abgTechnologysAccountUId?: string): Observable<Array<Account>> {
//       let url: string = this.coreGymService.BaseUrl!;

//       if (abgTechnologysAccountUId) {
//         url = url + this.coreGymService.serviceUrls!['GetAccountUIdUrl'];
//         url = url.replace('{id}', abgTechnologysAccountUId ? abgTechnologysAccountUId : Guid.empty);
//         return this.http.get(url)
//           .pipe(map((data: Array<Account>): Array<Account> => data, (_error: HttpErrorResponse) => { }));
//       }

//       url = url + this.coreGymService.serviceUrls!['GetAccountUrl'];
//       return this.http.get(url)
//         .pipe(map((data: Array<Account>): Array<Account> => data, (_error: HttpErrorResponse) => { }));
//     }

//     getAccountLogin(EmailId: string, Password: string): Observable<Array<Account>> {
//       let url: string = this.coreGymService.BaseUrl!;
//       url = url + this.coreGymService.serviceUrls!['AccountLogin'];
//       url = url.replace('{EmailId}', EmailId ? EmailId : '');
//       url = url.replace('{Password}', Password ? Password : '');

//       return this.http.get(url)
//         .pipe(map((data: Array<Account>): Array<Account> => data, (_error: HttpErrorResponse) => { }));
//     }

//     getAccountEmail(EmailId: string): Observable<Account> {
//       let url: string = this.coreGymService.BaseUrl!;
//       url = url + this.coreGymService.serviceUrls!['AccountEmail'];
//       url = url.replace('{EmailId}', EmailId ? EmailId : '');

//       return this.http.get(url)
//         .pipe(map((data: Account): Account => data, (_error: HttpErrorResponse) => { }));
//     }

//     deleteAccount(accountUId: Guid): Observable<Array<Account>> {
//       let url: string = this.coreGymService.BaseUrl!;
//       url = url + this.coreGymService.serviceUrls!['GetAccountUrl'];
//       url = url + '/' + accountUId;

//       return this.http.delete(url)
//         .pipe(map((data: Array<Account>): Array<Account> => data, (_error: HttpErrorResponse) => { }));
//     }

//     getAccountId(accountUId?: Guid): Observable<Account> {
//       let url: string = this.coreGymService.BaseUrl!;
//       url = url + this.coreGymService.serviceUrls!['GetAccountMaxIdUrl'];

//       return this.http.get(url)
//         .pipe(map((data: Account): Account => data, (_error: HttpErrorResponse) => { }));
//     }
//   resetPassword(target: string, code: string, newPassword: string): Observable<any> {
//       const url = this.buildUrl('api/ABGTechnologysAccounts/ResetPassword');
//       const body = { target, code, newPassword };

//       return this.http.post(url, JSON.stringify(body), { headers: this.jsonHeaders() })
//         .pipe(map((data: any) => data, (_error: HttpErrorResponse) => { }));
//     }

//   /** Step 1: create the unverified admin and send the OTP. -> POST api/auth/register/start */
//   register(payload: any): Observable<any> {
//     return this.http.post<any>(`${this.api}auth/register/start`, payload);
//   }

//   /** Step 2: confirm OTP + provision the tenant. -> POST api/auth/register/verify
//    *  payload = { email, emailCode, productCode, company: {...} }  (company forwarded verbatim) */
//   registerVerify(payload: any): Observable<any> {
//     return this.http.post<any>(`${this.api}auth/register/verify`, payload);
//   }

//   /** Re-issue the OTP for a pending registration. -> POST api/auth/register/start */
//   resendOtp(payload: any): Observable<any> {
//     return this.http.post<any>(`${this.api}auth/register/start`, payload);
//   }

//   /** Existing method the AccountCreation / Clientinfo grids rely on. */
//   // getAccount(): Observable<Array<Account>> {
//   //   return this.http.get<Array<Account>>(`${this.api}ABGTechnologysAccount`);
//   // }
// }


// import { Injectable } from '@angular/core';
// import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
// import { map } from 'rxjs/operators';
// import { Observable } from 'rxjs';
// import { CoreGymService } from '../../_services/core.gym.service.service';
// import { Account } from '../../model/account.model';
// import { AccountLogin } from '../../model/AccountLogin.model';
// import { Guid } from '../../_helpers/guid';

// @Injectable({
//   providedIn: 'root'
// })
// export class AccountService {

//   constructor(
//     private readonly http: HttpClient,
//     private readonly coreGymService: CoreGymService
//   ) {
//   }

//   mergeAccount(account: Account, action: string): Observable<Response> {
//     let httpheader = new HttpHeaders();
//     httpheader = httpheader.append('Content-Type', 'application/json');
//     let url: string = this.coreGymService.BaseUrl!;
//     url = url + this.coreGymService.serviceUrls!['GetAccountUrl'];
//     if (action === 'Edit' || action === 'Delete') {
//       url = url + '/' + account.abgTechnologysAccountUId;
//       return this.http.put(url, JSON.stringify(account), { 'headers': httpheader })
//         .pipe(map((data: Response) => data,
//           (error: HttpErrorResponse): void => {
//             console.log(error);
//           }
//         ));
//     } else {
//       return this.http.post(url, JSON.stringify(account), { 'headers': httpheader })
//         .pipe(map((data: Response) => data,
//           (error: HttpErrorResponse): void => {
//             console.log(error);
//           }
//         ));
//     }
//   }
//   /* (accountUId?: string):*/
//   getAccount(clientRegistrationUId?: string, productUId?: string): Observable<Array<Account>> {
//     let url: string = this.coreGymService.BaseUrl!;
//     url = url + this.coreGymService.serviceUrls!['GetAccountClientandProductUrl'];
//     url = url.replace('{clientRegistrationUId}', clientRegistrationUId ? clientRegistrationUId : Guid.empty);
//     url = url.replace('{productUId}', productUId ? productUId : Guid.empty);
//     //url = url.replace('{RegistrationUId}', RegistrationUId ? RegistrationUId : Guid.empty);

//     //url = url + '/' + accountUId;
//     //url = url.replace('{RegistrationUId}', accountUId ? accountUId : Guid.empty);

//     return this.http.get(url)
//       .pipe(map((data: Array<Account>): Array<Account> => data, (_error: HttpErrorResponse) => { }));

//   }

//   getAccountUId(abgTechnologysAccountUId?: string): Observable<Array<Account>> {
//     let url: string = this.coreGymService.BaseUrl!;
//     if (abgTechnologysAccountUId) {
//       url = url + this.coreGymService.serviceUrls!['GetAccountUIdUrl'];
//       url = url.replace('{id}', abgTechnologysAccountUId ? abgTechnologysAccountUId : Guid.empty);
//       return this.http.get(url)
//         .pipe(map((data: Array<Account>): Array<Account> => data, (_error: HttpErrorResponse) => { }));
//     }
//     else {
//       url = url + this.coreGymService.serviceUrls!['GetAccountUrl'];
//       return this.http.get(url)
//         .pipe(map((data: Array<Account>): Array<Account> => data, (_error: HttpErrorResponse) => { }));
//     }

//   }
//   getAccountLogin(EmailId: string, Password: string): Observable<Array<Account>> {
//     let url: string = this.coreGymService.BaseUrl!;
//     url = url + this.coreGymService.serviceUrls!['AccountLogin'];
//     url = url.replace('{EmailId}', EmailId ? EmailId : "");
//     url = url.replace('{Password}', Password ? Password : "");
//     let httpheader = new HttpHeaders();
//     httpheader = httpheader.append('Content-Type', 'application/json');
//     return this.http.get(url)
//       .pipe(map((data: Array<Account>): Array<Account> => data, (_error: HttpErrorResponse) => { }));
//   }
//   getAccountEmail(EmailId: string): Observable<Account> {
//     let url: string = this.coreGymService.BaseUrl!;
//     url = url + this.coreGymService.serviceUrls!['AccountEmail'];
//     url = url.replace('{EmailId}', EmailId ? EmailId : "");
//     let httpheader = new HttpHeaders();
//     httpheader = httpheader.append('Content-Type', 'application/json');
//     return this.http.get(url)
//       .pipe(map((data: Account): Account => data, (_error: HttpErrorResponse) => { }));
//   }


//   deleteAccount(accountUId: Guid): Observable<Array<Account>> {
//     let url: string = this.coreGymService.BaseUrl!;
//     url = url + this.coreGymService.serviceUrls!['GetAccountUrl'];
//     url = url + '/' + accountUId;
//     return this.http.delete(url)
//       .pipe(map((data: Array<Account>): Array<Account> => data, (_error: HttpErrorResponse) => { }));

//   }
//   getAccountId(accountUId?: Guid): Observable<Account> {
//     let url: string = this.coreGymService.BaseUrl!;
//     url = url + this.coreGymService.serviceUrls!['GetAccountMaxIdUrl'];
//     return this.http.get(url)
//       .pipe(map((data: Account): Account => data, (_error: HttpErrorResponse) => { }));

//   }
//   forgotsendmailpassword(account: Account) {
//     //let httpheader = new HttpHeaders();
//     //httpheader = httpheader.append('Content-Type', 'application/json');
//     let url: string = this.coreGymService.BaseUrl!;
//     url = url + this.coreGymService.serviceUrls!['GetforgotsendmailpasswordUrl'];
//     url = url + '/' + account.abgTechnologysAccountUId;
//     return this.http.put(url, JSON.stringify(account)/*, { 'headers': httpheader }*/)
//       .pipe(map((data: Response) => data,
//         (error: HttpErrorResponse): void => {
//           console.log(error);
//         }
//       ));
//   }
// }


import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { environment } from '../../../environments/environment'; // <-- fix path if your env file differs
import { Account } from '../../model/account.model';
import { CoreGymService } from '../../_services/core.gym.service.service';
import { Guid } from '../../_helpers/guid';

/**
 * AccountService — auth/registration calls used by the unified register wizard + AccountCreation grid.
 *
 * IMPORTANT: register() and registerVerify() post the WHOLE payload object as-is, so the new
 * `company` block reaches the backend untouched. That was the seam that would otherwise silently
 * drop CompanyDetails.
 *
 * If your existing AccountService has other methods (it does — e.g. getAccount is used by
 * Clientinfo/AccountCreation), keep them; just make sure register/registerVerify look like this.
 */
@Injectable({ providedIn: 'root' })
export class AccountService {


  private readonly api = "https://localhost:7027/api/";

  constructor(private readonly http: HttpClient,
    private readonly coreGymService: CoreGymService) { }

  private jsonHeaders(): HttpHeaders {
    let httpheader = new HttpHeaders();
    httpheader = httpheader.append('Content-Type', 'application/json');
    return httpheader;
  }

  private buildUrl(path: string): string {
    const baseUrl = this.coreGymService.BaseUrl || '';
    if (!baseUrl.endsWith('/') && !path.startsWith('/')) {
      return baseUrl + '/' + path;
    }
    return baseUrl + path;
  }


  mergeAccount(account: Account, action: string): Observable<Response> {
    const httpheader = this.jsonHeaders();
    let url: string = this.coreGymService.BaseUrl!;
    url = url + this.coreGymService.serviceUrls!['GetAccountUrl'];

    if (action === 'Edit' || action === 'Delete') {
      url = url + '/' + account.abgTechnologysAccountUId;
      return this.http.put(url, JSON.stringify(account), { headers: httpheader })
        .pipe(map((data: Response) => data, (error: HttpErrorResponse): void => console.log(error)));
    }

    return this.http.post(url, JSON.stringify(account), { headers: httpheader })
      .pipe(map((data: Response) => data, (error: HttpErrorResponse): void => console.log(error)));
  }

  getAccount(clientRegistrationUId?: string, productUId?: string): Observable<Array<Account>> {
    let url: string = this.coreGymService.BaseUrl!;
    url = url + this.coreGymService.serviceUrls!['GetAccountClientandProductUrl'];
    url = url.replace('{clientRegistrationUId}', clientRegistrationUId ? clientRegistrationUId : Guid.empty);
    url = url.replace('{productUId}', productUId ? productUId : Guid.empty);

    return this.http.get(url)
      .pipe(map((data: Array<Account>): Array<Account> => data, (_error: HttpErrorResponse) => { }));
  }

  getAccountUId(abgTechnologysAccountUId?: string): Observable<Array<Account>> {
    let url: string = this.coreGymService.BaseUrl!;

    if (abgTechnologysAccountUId) {
      url = url + this.coreGymService.serviceUrls!['GetAccountUIdUrl'];
      url = url.replace('{id}', abgTechnologysAccountUId ? abgTechnologysAccountUId : Guid.empty);
      return this.http.get(url)
        .pipe(map((data: Array<Account>): Array<Account> => data, (_error: HttpErrorResponse) => { }));
    }

    url = url + this.coreGymService.serviceUrls!['GetAccountUrl'];
    return this.http.get(url)
      .pipe(map((data: Array<Account>): Array<Account> => data, (_error: HttpErrorResponse) => { }));
  }

  getAccountLogin(EmailId: string, Password: string): Observable<Array<Account>> {
    let url: string = this.coreGymService.BaseUrl!;
    url = url + this.coreGymService.serviceUrls!['AccountLogin'];
    url = url.replace('{EmailId}', EmailId ? EmailId : '');
    url = url.replace('{Password}', Password ? Password : '');

    return this.http.get(url)
      .pipe(map((data: Array<Account>): Array<Account> => data, (_error: HttpErrorResponse) => { }));
  }

  getAccountEmail(EmailId: string): Observable<Account> {
    let url: string = this.coreGymService.BaseUrl!;
    url = url + this.coreGymService.serviceUrls!['AccountEmail'];
    url = url.replace('{EmailId}', EmailId ? EmailId : '');

    return this.http.get(url)
      .pipe(map((data: Account): Account => data, (_error: HttpErrorResponse) => { }));
  }

  deleteAccount(accountUId: Guid): Observable<Array<Account>> {
    let url: string = this.coreGymService.BaseUrl!;
    url = url + this.coreGymService.serviceUrls!['GetAccountUrl'];
    url = url + '/' + accountUId;

    return this.http.delete(url)
      .pipe(map((data: Array<Account>): Array<Account> => data, (_error: HttpErrorResponse) => { }));
  }

  getAccountId(accountUId?: Guid): Observable<Account> {
    let url: string = this.coreGymService.BaseUrl!;
    url = url + this.coreGymService.serviceUrls!['GetAccountMaxIdUrl'];

    return this.http.get(url)
      .pipe(map((data: Account): Account => data, (_error: HttpErrorResponse) => { }));
  }
  resetPassword(target: string, code: string, newPassword: string): Observable<any> {
    const url = this.buildUrl('api/ABGTechnologysAccounts/ResetPassword');
    const body = { target, code, newPassword };

    return this.http.post(url, JSON.stringify(body), { headers: this.jsonHeaders() })
      .pipe(map((data: any) => data, (_error: HttpErrorResponse) => { }));
  }

  /** Step 1: create the unverified admin and send the OTP. -> POST api/auth/register/start */
  register(payload: any): Observable<any> {
    return this.http.post<any>(`${this.api}auth/register/start`, payload);
  }

  /** Step 2: confirm OTP + provision the tenant. -> POST api/auth/register/verify
   *  payload = { email, emailCode, productCode, company: {...} }  (company forwarded verbatim) */
  registerVerify(payload: any): Observable<any> {
    return this.http.post<any>(`${this.api}auth/register/verify`, payload);
  }

  /** Re-issue the OTP for a pending registration. -> POST api/auth/register/start */
  resendOtp(payload: any): Observable<any> {
    return this.http.post<any>(`${this.api}auth/register/start`, payload);
  }
  completeOnboarding(payload: any): Observable<any> {
    return this.http.post<any>(this.buildUrl('api/ABGTechnologysAccounts/CompleteOnboarding'), payload, { headers: this.jsonHeaders() });
  }


  /** Existing method the AccountCreation / Clientinfo grids rely on. */
  // getAccount(): Observable<Array<Account>> {
  //   return this.http.get<Array<Account>>(`${this.api}ABGTechnologysAccount`);
  // }
}



